<template>
	<div id="app">
		<!-- 回到顶部 -->
		<el-backtop :right="5" :bottom="20">
			<!-- <i class="el-icon-caret-top"></i> -->
		</el-backtop>
		<!-- 右侧联系方式 -->
		<Contact></Contact>

		<!-- <div :class="{'banner':true,'banner_canvas':showCanvas}"> -->
		<!-- 页头 -->
		<!-- <Header></Header> -->
		<!-- 首页轮播 -->
		<!-- <Banner></Banner> -->
		<!-- Canvas动画 -->
		<CanvasParticle v-bind:showCanvas="showCanvas" v-on:SetShowCanvas="SetShowCanvas"></CanvasParticle>
		<!-- </div> -->

		<!-- 模态框 -->
		<Modal></Modal>
		<!-- 服务项目 -->
		<Services></Services>
		<!-- 业务覆盖范围 -->
		<!-- <Business></Business> -->
		<!-- 服务至上 -->
		<ServiceIdea></ServiceIdea>
		<!-- 商标注册流程 -->
		<div style="text-align: center;">
			<img src="../../assets/images/common/sbzclc.png" alt="商标注册流程" style="width: 100%;">
		</div>
		<!-- 案例展示 -->
		<!-- <Case></Case> -->
		<!-- 常见问题 -->
		<Question></Question>
		<!-- 商标注册的好处 -->
		<Profit></Profit>
		<!-- 新闻动态 -->
		<News></News>
		<!-- 团队 -->
		<!-- <Team></Team> -->
		<!-- 关于我们 -->
		<About v-if="showIndex>=2"></About>
		<!-- 地图 -->
		<Map></Map>
		<!-- 联系我们 -->
		<Contactus v-if="showIndex>=2"></Contactus>
		<!-- 页脚 -->
		<Footer v-if="showIndex>=2"></Footer>
	</div>
</template>

<script>
	// //引入组件
	// import Contact from '../../components/Contact.vue';
	// // import Header from '../../components/Header.vue';
	// // import Banner from '../../components/Banner.vue';
	// import CanvasParticle from '../../components/CanvasParticle.vue';
	// import Modal from '../../components/Modal.vue';
	// import Services from '../../components/Services.vue';
	// // import Business from '../../components/Business.vue';
	// // import Case from '../../components/Case.vue';
	// import Question from '../../components/Question.vue';
	// import Profit from '../../components/Profit.vue';
	// import ServiceIdea from '../../components/ServiceIdea.vue';
	// import News from '../../components/News.vue';
	// // import Team from '../../components/Team.vue';
	// import About from '../../components/About.vue';
	// import Map from '../../components/Map.vue';
	// import Contactus from '../../components/Contactus.vue';
	// import Footer from '../../components/Footer.vue';
	export default {
		name: 'IndexApp',
		data() {
			return {
				showCanvas: false, //默认不显示
				showIndex: 2, //显示的模块索引
			}
		},
		// 计算属性
		computed: {
			// // 测试Vuex
			// // 由于 Vuex 的状态存储是响应式的，从 store 实例中读取状态最简单的方法就是在计算属性中返回某个状态：
			// count() {
			// 	return this.$store.state.count;
			// },
			// // 箭头函数可使代码更简练
			// // count: state => state.count,
			// // mapState辅助函数
			// // 对象展开运算符,mapState 函数返回的是一个对象, 使用对象展开运算符将此对象混入到外部对象中
			// ...mapState({
			// 	// 'count' // 映射 this.count 为 store.state.count
			// }),
			// //使用store.getters
			// doneTodosCount() {
			// 	return this.$store.getters.doneTodosCount
			// },
			// // mapGetters 辅助函数
			// // 使用对象展开运算符将 getter 混入 computed 对象中
			// ...mapGetters([
			// 	'doneTodos',
			// 	'getTodoById'
			// ]),
			// ...mapGetters({
			// 	// 把 `this.doneCount` 映射为 `this.$store.getters.doneTodosCount`
			// 	doneCount: 'doneTodosCount'
			// })
		},
		components: {
			// Contact,
			// // Header,
			// // Banner,
			// CanvasParticle,
			// Modal,
			// Services,
			// // Business,
			// // Case,
			// Question,
			// Profit,
			// ServiceIdea,
			// News,
			// // Team,
			// About,
			// Map,
			// Contactus,
			// Footer

			// 组件懒加载
			Contact: resolve => {
				require(['../../components/Contact.vue'], resolve)
			},
			// Header: resolve => {
			// 	require(['../../components/Header.vue'], resolve)
			// },
			// Banner: resolve => {
			// 	require(['../../components/Banner.vue'], resolve)
			// },
			CanvasParticle: resolve => {
				require(['../../components/CanvasParticle.vue'], resolve)
			},
			Modal: resolve => {
				require(['../../components/Modal.vue'], resolve)
			},
			Services: resolve => {
				require(['../../components/Services.vue'], resolve)
			},
			// Business: resolve => {
			// 	require(['../../components/Business.vue'], resolve)
			// },
			// Case: resolve => {
			// 	require(['../../components/Case.vue'], resolve)
			// },
			Question: resolve => {
				require(['../../components/Question.vue'], resolve)
			},
			Profit: resolve => {
				require(['../../components/Profit.vue'], resolve)
			},
			ServiceIdea: resolve => {
				require(['../../components/ServiceIdea.vue'], resolve)
			},
			News: resolve => {
				require(['../../components/News.vue'], resolve)
			},
			// Team: resolve => {
			// 	require(['../../components/Team.vue'], resolve)
			// },
			About: resolve => {
				require(['../../components/About.vue'], resolve)
			},
			Map: resolve => {
				require(['../../components/Map.vue'], resolve)
			},
			Contactus: resolve => {
				require(['../../components/Contactus.vue'], resolve)
			},
			Footer: resolve => {
				require(['../../components/Footer.vue'], resolve)
			}
		},
		methods: {
			//修改Canvas显示状态
			SetShowCanvas: function(data) {
				this.showCanvas = data;
			},
			// 滚动加载
			HandleScroll: function() {
				// 获取这个组件距离页面顶部的高度，如果这个高度小于页面的高度。。。。。
				// 获取距离顶部高度this.$refs.xxxx.getBoundingClientRect().top, 
				// 还有一个要注意的地方，就该组件还没渲染，找不到怎么办，用一个div包着它找这个div，但是这个div最小高度是1，不能没有高度，原因，是浏览器兼容问题;
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				//变量windowHeight是可视区的高度
				const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				//滚动条到底部的条件
				if (scrollTop + windowHeight == scrollHeight) {
					if (this.showIndex > 2) {
						this.showIndex = 2;
					} else {
						this.showIndex++;
					}
				}
			}
		},
		mounted: function() { //()=> 可能会提示undefined
			let self_ = this;
			window.onload = function() {
				//默认滚动到指定位置
				const arrAto = location.href.match(/\#\S+/gi);
				if (!arrAto || arrAto.length == 0) {
					//页面刷新滚动条重回顶部
					window.setTimeout(function() {
						document.body.scrollTop = 0;
						document.documentElement.scrollTop = 0;
						window.scrollTo(0, 0);
					}, 500);
				} else {
					$('html, body').animate({
						scrollTop: $(arrAto[0]).offset().top
					}, 500)
				}
			};
			// 因地图等模块加载太慢,滚动加载会有点击导航栏跳转不过去的可能,因此不做滚动加载
			// 监听滚动事件
			// window.addEventListener('scroll', this.HandleScroll);
		}
	}
</script>

<style>
	html {
		width: 100%;
		overflow-x: hidden;
	}

	#app {
		background-color: #000;
		color: #fff;
	}
</style>
